import gql from 'graphql-tag';

export default gql`
query getPagesCountOfProject($projectId: Int!) {
  pages_aggregate(where: { parent_project_id: { _eq: $projectId } }) {
    aggregate { count }
  }
}
`;
